import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { Store } from '@ngrx/store';
import { filter } from 'rxjs';

import { UsersSelectors } from '../..';

export const usersLoadedResolver: ResolveFn<boolean> = () => {
  const store = inject(Store);

  return store.select(UsersSelectors.getLoaded).pipe(filter(Boolean));
};
